import clsx from 'clsx'
import { twMerge } from 'tailwind-merge'

import { SeatStatus } from 'config/constants'

export function getStatusColor(status) {
  switch (status) {
    case SeatStatus.Empty:
      return '#ffffff' // white
    case SeatStatus.Available:
      return '#a5d6a7' // light green
    case SeatStatus.Reserved:
      return '#fff59d' // light yellow
    case SeatStatus.Sold:
      return '#ef9a9a' // light red
    case SeatStatus.Disabled:
      return '#bdbdbd' // gray
    case SeatStatus.Blocked:
      return '#90caf9' // light blue
    case SeatStatus.ToSell:
      return '#ba68c8' // light purple
    case SeatStatus.SoldSelected:
      return '#db3434ff'
    default:
      return '#ffffff'
  }
}

export function getStatusName(status) {
  switch (status) {
    case SeatStatus.Empty:
      return 'Vacío'
    case SeatStatus.Available:
      return 'Disponible'
    case SeatStatus.Reserved:
      return 'Pendiente'
    case SeatStatus.Sold:
    case SeatStatus.SoldSelected:
      return 'Vendido'
    case SeatStatus.Disabled:
      return 'Deshabilitado'
    case SeatStatus.Blocked:
      return 'Reservado'
    case SeatStatus.ToSell:
      return 'Seleccionado'
    default:
      return 'Desconocido'
  }
}

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}
